import { render, staticRenderFns } from "./DisciplineAdmin.vue?vue&type=template&id=0589bd4c&scoped=true&"
import script from "./DisciplineAdmin.vue?vue&type=script&lang=js&"
export * from "./DisciplineAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589bd4c",
  null
  
)

export default component.exports